module.exports = __webpack_public_path__ + "img/pousada-barranco-alto.182e2574.jpg";